import React from "react";
import { cn } from "@/lib/utils";

const STATES = {
  EM_OPERACAO: {
    label: "Em Operação",
    bg: "bg-emerald-50",
    text: "text-emerald-700",
    border: "border-emerald-200",
    dot: "bg-emerald-500",
  },
  EM_ANDAMENTO: {
    label: "Em Andamento",
    bg: "bg-amber-50",
    text: "text-amber-700",
    border: "border-amber-200",
    dot: "bg-amber-500",
  },
  AGUARDANDO_FATURAMENTO: {
    label: "Aguardando Faturamento",
    bg: "bg-orange-50",
    text: "text-orange-700",
    border: "border-orange-200",
    dot: "bg-orange-500",
  },
  FATURADO: {
    label: "Faturado",
    bg: "bg-slate-100",
    text: "text-slate-700",
    border: "border-slate-300",
    dot: "bg-slate-500",
  },
};

export default function StatusBadge({ status, className }) {
  const s = STATES[status] || STATES.EM_OPERACAO;
  return (
    <span
      data-testid="work-order-status-badge"
      className={cn(
        "ag-status-badge gap-1.5",
        s.bg,
        s.text,
        s.border,
        className,
      )}
    >
      <span className={cn("inline-block w-1.5 h-1.5 rounded-full", s.dot)} />
      {s.label}
    </span>
  );
}

export { STATES };
